import React from 'react'
import { Formik, Field } from 'formik'
import { useIntl } from 'react-intl'
import { Button, Form } from 'lib/ui/components'
import { InterceptBlurEvent } from 'lib/ui/components/Form/types'
import { usePwaForm } from 'hooks/pwaForm'
import { captureEmail } from 'modules/listrak'
import { schema, validation, FormValues } from './schema'
import { Wrapper } from './styled'

export const ContactForm = () => {
  const { formatMessage } = useIntl()
  const {
    submitForm,
    isFetching,
    isSuccess
  } = usePwaForm('sg_contact_us')

  const handleSubmit = (values: FormValues) => {
    const formFields = [
      { code: 'name', value: values.name },
      { code: 'email', value: values.email },
      { code: 'phone', value: values.phone },
      { code: 'comment', value: values.comment }
    ]
    submitForm(formFields)
  }

  return (
    <Wrapper>
      {isSuccess ? (
        <h2 className='success'>
          Your message has been successfully sent. <br /> We will contact you as soon as possible.
        </h2>
      ) : (
        <Formik
          initialValues={schema}
          validationSchema={validation(formatMessage)}
          onSubmit={handleSubmit}
        >
          <Form.Wrapper>
            <Field
              name='name'
              label='Name'
              component={Form.Input}
              isRequired
              autoFocus
            />
            <Field
              name='email'
              label={formatMessage({
                id: 'customer.account.login.label.email'
              })}
              component={Form.Input}
              interceptBlur={(e: InterceptBlurEvent<string>) => {
                captureEmail(e.value)
              }}
              isRequired
            />

            <Field
              name='phone'
              label='Phone Number'
              component={Form.Input}
            />

            <Field
              name='comment'
              label='Whats on your mind?'
              component={Form.TextArea}
              isRequired
            />

            <Form.Actions.Wrapper>
              <Button
                type='submit'
                isLoading={isFetching}
              >
                Submit
              </Button>
            </Form.Actions.Wrapper>
          </Form.Wrapper>
        </Formik>
      )}
    </Wrapper>
  )
}
